






import Vue from 'vue';
import {Component} from "vue-property-decorator";
import AsiLoginForm from "@/components/common/AsiLoginForm.vue";

@Component({
	components: {AsiLoginForm}
})
export default class Login extends Vue {

}
